module.exports = __webpack_public_path__ + "img/madness_1248.6f6cc3ed.png";